import { message } from "ant-design-vue";
import {
  postPayloadAuth,
  postPayloadCommands,
  PayloadCommandsEnum,
  PostCameraModeBody,
  PostCameraFocalLengthBody,
  PostGimbalResetBody,
  PostCameraAimBody,
} from "/@/api/drone-control/payload";
import { ControlSource } from "/@/types/device";
// const controller = new AbortController();
export function usePayloadControl() {
  function checkPayloadAuth(controlSource?: ControlSource) {
    if (controlSource !== ControlSource.A) {
      // message.error('请先获取负载控制')
      return false;
    }
    return true;
  }

  async function authPayload(sn: string, payloadIndx: string) {
    const { code } = await postPayloadAuth(sn, {
      payload_index: payloadIndx,
    });
    if (code === 0) {
      // message.success('获取负载控制成功')
      return true;
    }
    return false;
  }

  async function resetGimbal(sn: string, data: PostGimbalResetBody) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.GimbalReset,
      data: data,
    });
    if (code === 0) {
      // message.success('云台控制设置成功')
    }
  }

  async function switchCameraMode(sn: string, data: PostCameraModeBody) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.CameraModeSwitch,
      data: data,
    });
    if (code === 0) {
      // message.success('切换成功')
    }
  }

  async function takeCameraPhoto(
    sn: string,
    payloadIndx: string,
    storage = ""
  ) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.CameraPhotoTake,
      data: {
        payload_index: payloadIndx,
      },
      storage,
    });
    // if (code === 0) {
    //   message.success("拍照成功");
    // }
  }
  // 切换相机模式
  async function photoChangeCamera(
    sn: string,
    payloadIndx: string,
    flag: boolean
  ) {
    // flag true为拍照 false录像
    const cmd = flag ? "camera_photo_take" : "camera_mode_switch";
    const { code } = await postPayloadCommands(sn, {
      cmd: "camera_mode_switch",
      data: {
        payload_index: payloadIndx,
        camera_mode: flag ? 0 : 1,
      },
    });
    return code;
    // if (code === 0) {
    //   // message.success('切换相机模式')
    // }
  }

  async function startCameraRecording(
    sn: string,
    payloadIndx: string,
    storage = ""
  ) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.CameraRecordingStart,
      data: {
        payload_index: payloadIndx,
      },
      storage,
    });
    return code;
    // if (code === 0) {
    //   message.success("开始录制成功");
    // }
  }

  async function stopCameraRecording(sn: string, payloadIndx: string) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.CameraRecordingStop,
      data: {
        payload_index: payloadIndx,
      },
    });
    return code;
    // if (code === 0) {
    //   message.success("结束录制成功");
    // }
  }

  async function changeCameraFocalLength(
    sn: string,
    data: PostCameraFocalLengthBody
  ) {
    // const res = await postPayloadCommands(sn, {
    //   cmd: PayloadCommandsEnum.CameraFocalLengthSet,
    //   data: data,
    // })
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.CameraFocalLengthSet,
      data: data,
    });
    if (code === 0) {
      // message.success("成功");
    }
    // else{
    //   controller.abort();
    // }
  }

  async function cameraAim(sn: string, data: PostCameraAimBody) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.CameraAim,
      data: data,
    });
    if (code === 0) {
      // message.success('目标点设置成功')
    }
  }

  return {
    checkPayloadAuth,
    authPayload,
    resetGimbal,
    switchCameraMode,
    takeCameraPhoto,
    startCameraRecording,
    stopCameraRecording,
    changeCameraFocalLength,
    cameraAim,
    photoChangeCamera,
  };
}
